export default "__VITE_ASSET__A50FmHMX__"